import {takeLatest} from 'redux-saga/effects';

import {getBeerStyleBeersSaga} from './getBeers/saga';
import {getSingleBeerStyleSaga} from './GetBeerStyle/saga';
import {getBeerStyleBeersACS, getSingleBeerStyleACS} from './requests';

export function* beerStylePreviewSaga() {
  yield takeLatest(getSingleBeerStyleACS.type, getSingleBeerStyleSaga);
  yield takeLatest(getBeerStyleBeersACS.type, getBeerStyleBeersSaga);
}
